import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      /Loading chunk \d+ failed/i.test(error?.message || '') ||
      /Failed to fetch dynamically imported module/i.test(error?.message || '');
    return { hasError: true, isChunkError };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
    // Auto-reload once on chunk errors (stale cache after deploy)
    if (this.state.isChunkError) {
      const key = 'bacc_chunk_reload';
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        window.location.reload();
      }
    }
  }

  handleReload = () => {
    sessionStorage.removeItem('bacc_chunk_reload');
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white px-6">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 border-4 border-[#C9A84C] border-t-transparent rounded-full animate-spin mx-auto mb-6" />
            <h2 className="text-xl font-semibold text-[#1A1F4B] mb-2">
              {this.state.isChunkError ? 'Atualizando o site...' : 'Algo deu errado'}
            </h2>
            <p className="text-gray-500 text-sm mb-6">
              {this.state.isChunkError
                ? 'Uma nova versão do site está disponível. Recarregando automaticamente...'
                : 'Ocorreu um erro inesperado nesta página.'}
            </p>
            <button
              onClick={this.handleReload}
              className="px-6 py-2 bg-[#1A1F4B] text-white rounded-lg hover:bg-[#C9A84C] transition-colors text-sm"
            >
              Recarregar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
